import auth from '../auth'
import Webapi from './webapi'
import dev from './dev'

const contentTypeV1 = dev('application/json', 'application/vnd.budbee.lockers-v1+json')

const contentTypeV2 = dev('application/json', 'application/vnd.budbee.lockers-v2+json')

const webapi = () =>
    new Webapi()
        .authorization(auth.get())
        .accept(contentTypeV2)
        .contentType(contentTypeV2)
        .path('lockers')

// getLockers is needed for creating standalone returns
export const getLockers = (countryCode, postalCode, useInNumber = false) => {
    let request = webapi()
        .path('available-lockers')
        .path(countryCode)
        .path(postalCode)
        .queryParam('language', 'SE')
        .queryParam('fromPlaceApi', true)

    if (useInNumber) {
        request = request.queryParam('identifier', 'in-number')
    }

    return request
        .header('Accept', contentTypeV1)
        .header('Content-Type', contentTypeV1)
        .header('Authorization', auth.get())
        .get()
}
